// extracted by mini-css-extract-plugin
export var fullWidthButton = "_fd-0";